<template>
  <div class="custom-data">
    <custom-data-balance class="m-b-16" />

    <!-- 数据导出记录 -->
    <div class="history-card">
      <div class="history-card-header">
        <div class="history-card-header__title">数据导出记录</div>
      </div>
      <div v-if="history.length > 0" class="history-list">
        <jczh-table-content
          :data="history"
          :option="historyOption"
          pagination
          :total="total"
          :page.sync="page"
          :limit.sync="size"
          :header-cell-style="{ background: '#f5f5f5', color: '#333' }"
          @pagination="getList"
        >
          <template v-slot:status="{ row }">
            <div class="flex row-center">
              <status-tag
                :label="customDataExportStatusDict.translate(row.status).label"
                :type="customDataExportStatusDict.translate(row.status).status"
                :label-style="{ fontSize: '14px' }"
              />
            </div>
          </template>
          <template v-slot:last>
            <el-table-column align="center" label="操作">
              <template v-slot:default="{ row }">
                <el-button
                  type="text"
                  @click="handleDownload(row)"
                >再次下载</el-button>
              </template>
            </el-table-column>
          </template>
        </jczh-table-content>
      </div>

      <div v-else class="history-list">
        <el-empty
          description="暂无数据"
          :image="require('@/assets/images/personal-center/empty.png')"
          :image-size="64"
        />
      </div>
    </div>
  </div>
</template>

<script>
// 组件
import CustomDataBalance from '@/components/PersonalCenter/CustomDataBalance'
import StatusTag from '@/components/StatusTag'
// 工具
import { debounce } from 'lodash'
// 字典
import { customDataExportStatusDict } from '@/dictionary/value-added-service'
import {
  downloadCustomDataAgainApi,
  getCustomDataExportHistoryApi,
  getCustomDataExportURLApi
} from '@/api/value-added-service'

export default {
  name: 'CustomData',

  components: { CustomDataBalance, StatusTag },

  data() {
    return {
      customDataExportStatusDict,

      history: [],
      total: 0,
      page: 1,
      size: 10,

      historyOption: [
        { label: '导出时间', prop: 'exportTime', minWidth: 160 },
        { label: '导出条数', prop: 'total', minWidth: 120 },
        {
          label: '导出状态',
          prop: 'status',
          minWidth: 120,
          slotName: 'status'
        }
      ]
    }
  },

  created() {
    this.getList()
  },

  methods: {
    getList() {
      const params = {
        page: this.page,
        size: this.size
      }
      getCustomDataExportHistoryApi(params)
        .then(res => {
          this.history = res.data.records || []
          this.total = res.data.total || 0
        })
        .catch(err => {
          console.error('获取数据定制导出历史列表失败', err)
          if (err?.message) this.$message.error(err.message)
        })
    },

    /**
     * 重新下载定制的数据
     */
    handleDownload: debounce(function(row) {
      // 如果导出成功，则直接获取下载链接进行下载
      if (row.status === customDataExportStatusDict.SUCCESS.value) {
        this.openDownloadUrl(row.bizCode)
      }
      // 如果导出不成功，则需要重新生成新的bizCode，再调用下载，调用成功后需要刷新列表
      if (row.status === customDataExportStatusDict.FAIL.value) {
        downloadCustomDataAgainApi(row.bizCode)
          .then(res => {
            this.openDownloadUrl(res.data.bizCode)
            this.getList()
          })
          .catch(err => {
            if (err?.data?.message) this.$message.error(err.data.message)
          })
      }
    }, 1000),

    /**
     * 打开下载地址
     */
    openDownloadUrl(bizCode) {
      getCustomDataExportURLApi(bizCode)
        .then(res => {
          window.open(res.data.external, '_blank')
        })
        .catch(err => {
          console.error('根据业务编号查询OSS文件路径失败', err)
          if (err?.data?.message) this.$message.error(err.data.message)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-data {
  width: 100%;

  .history-card {
    width: 100%;
    border-radius: 4px;
    background: $white-color;
    padding: 24px;

    .history-card-header {
      margin-bottom: 24px;
      display: flex;
      align-items: flex-end;

      .history-card-header__title {
        font-size: 16px;
        color: $text-color;
        @include text-bold;

        &::before {
          content: '';
          display: inline-block;
          width: 4px;
          height: 16px;
          background: $primary-color;
          margin-right: 6px;
          vertical-align: -12%;
        }
      }
    }
  }
}
</style>
